import { Box } from '@mui/material';
import { axiosHelper } from '@root/services/axios';
import { useMutation } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import './tenatswitch.scss';
// import AppContext from '../../context/Context';
import agent from '@root/agent';
import profile from '@root/assets/svg/icons/new/identity/Profile.svg';
import { SET_USER } from '@root/constants/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import SubTenatSwitchingErrorModal from './TenantSwitchingError';
import SideOverlay from '@root/components/common/SideOverlayNew';
import { ChevronDown } from 'lucide-react';
// import users_selected from '@root/assets/svg/icons/new/selected/Users.svg';
import './TopNavbar.scss';
// import { Tooltip } from '@mui/material';
import ChangePasswordIcon from '@root/assets/svg/Authentication/ChangePasswordIcon';
import HelpIcon from '@root/assets/svg/Navigation/HelpIcon';
import LogoutIcon from '@root/assets/svg/Authentication/LogoutIcon';
// import SettingsIcon from '@root/assets/svg/Navigation/SettingsIcon';
import SwitchTenanticon from '@root/assets/svg/Navigation/SwitchTenanticon';
import SupportHandIcon from '@root/assets/svg/Utility/SupportHandIcon';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import TenantSwitchingNew from './TenantSwitchingNew';
import Profile from '@root/pages/profile';

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

const ProfileDropdown = ({ user }) => {
  const dispatch = useDispatch();
  const [tenantList, setTenantlist] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [delayed, setDelayed] = useState(false);
  const [currentTenant, setCurrentTenant] = useState([]);
  const toggle = useCallback(() => setDropdownOpen(prevState => !prevState), []);
  const [templist, setTempList] = useState([]);
  const [openSideOverlay, setOpenSideOverlay] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [checked, setChecked] = useState(true);
  const [value, setValue] = useState('');
  const [tempTenant, setTempTenant] = useState([]);
  const [errormodalShow, setErrorModalShow] = useState(false);
  const is_org_owner = useSelector(state => state?.user?.info?.user?.is_org_owner);

  // Fetch tenant list from localStorage instead of Redux
  useEffect(() => {
    const storedTenants = localStorage.getItem('subtenant');
    if (storedTenants) {
      try {
        const tenantData = JSON.parse(storedTenants);
        setTenantlist(tenantData);
        setTempList(tenantData);
        if (localStorage.getItem('tenantName')) {
          setCurrentTenant(localStorage.getItem('tenantName'));
        }
      } catch (error) {
        console.error('Error parsing tenant data from localStorage:', error);
      }
    }
  }, []); // Run once on component mount
  const onSearch = event => {
    // TODO: Future Bug. Searching will reset the selected values most probably.
    // let original = groupsnusers
    let query = event.target.value;
    if (query !== '') {
      setValue(query);
      let newArray = tenantList.filter(obj =>
        JSON.stringify(obj['tenant_name']).toLowerCase().includes(query?.toLowerCase()),
      );
      if (isEmpty(newArray)) {
        setChecked(true);
      }
      setTempList(newArray);
    } else {
      setTempTenant([]);
      setTempList(tenantList);
      setChecked(true);
      setValue('');
    }
  };

  const onTenantSelect = element => {
    if (!tempTenant.includes(element)) {
      setTempTenant([element]);
      setChecked(false);
    }
  };
  const setTenant = async () => {
    if (!isEmpty(tempTenant)) {
      try {
        // Get the new tenant name that user is switching to
        const newTenantName = tempTenant[0]['tenant_name'];

        // Call the refresh token API - cookies are handled automatically by withCredentials
        const refreshResponse = await agent.Auth.refreshToken(null, newTenantName);
        if (refreshResponse?.error === 1) {
          // If refresh fails, redirect to login
          toast.error('Session expired. Please login again.');
          handleLogout();
          return;
        }
        // Tokens are now handled via HTTP-only cookies, no need to store in localStorage

        let tenant = tenantList.filter(e => e.tenant_name === tempTenant[0]['tenant_name']);
        localStorage.setItem('tenantName', tenant[0]['tenant_name']);
        localStorage.setItem('tenantID', tenant[0]['id']);
        localStorage.removeItem('User Policy');
        localStorage.removeItem('User Policy Table');
        localStorage.removeItem('environments');

        // Call user API to get updated user data with new tenant ID
        try {
          const updatedUserInfo = await agent.Auth.current();
          if (updatedUserInfo) {
            // Update Redux store with new user data
            dispatch({ type: SET_USER, payload: updatedUserInfo });
            // Update localStorage with new user data
            localStorage.setItem('User', JSON.stringify(updatedUserInfo));
          }
        } catch (userApiError) {
          console.error('Error fetching updated user data after tenant switch:', userApiError);
          // Continue with tenant switch even if user API fails
        }

        setCurrentTenant(tenant);
        setModalShow(false);
        window.location.href = '/';
      } catch (error) {
        console.error('Error during tenant switch:', error);
        toast.error('Failed to switch tenant. Please try again.');
      }
    } else {
      toast.error('Please Select at least one tenant');
    }
  };

  const handleLogout = () => {
    // Clear non-auth localStorage items (auth cookies are cleared by server on /logout)
    window.localStorage.removeItem('User');
    window.localStorage.removeItem('tenantName');
    window.localStorage.removeItem('tenantID');
    window.localStorage.removeItem('subtenant');
    window.localStorage.clear();
    window.open('/login', '_self');
  };

  const handleOpenSideOverlay = () => {
    setOpenSideOverlay(true);
  };

  const handleCloseSideOverlay = useCallback(() => {
    setOpenSideOverlay(false);
  }, []);

  const getHelpMutation = useMutation({
    mutationFn: async () => {
      const response = await agent.ClientDashboard.get_help();
      const url = response?.data?.signedUrl;

      if (!url) throw new Error('No help url found.');

      window.open(url, '_blank');
    },
    onError: async e => {
      toast.error(`Failed to open Help: ${e?.message || ''}`);
    },
  });

  const handleHelpClick = useCallback(() => {
    getHelpMutation.mutate();
  }, [getHelpMutation]);

  // Zendesk JWT SSO Integration
  const submitToZendesk = useCallback((jwtToken, returnTo = null) => {
    // Create and submit form (required by Zendesk)
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://seclogicinc.zendesk.com/access/jwt';
    form.style.display = 'none';
    form.target = '_blank'; // Open in new tab

    // Add JWT token
    const jwtInput = document.createElement('input');
    jwtInput.type = 'hidden';
    jwtInput.name = 'jwt';
    jwtInput.value = jwtToken;
    form.appendChild(jwtInput);

    // Add return_to if provided
    if (returnTo) {
      const returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      returnToInput.value = returnTo;
      form.appendChild(returnToInput);
    }

    document.body.appendChild(form);
    form.submit();
  }, []);

  const authenticateWithZendesk = useCallback(
    async (userData, returnTo = null) => {
      try {
        // With cookie-based auth, no need to check for access token
        // Cookies are automatically sent with API requests via withCredentials

        // Check if user is logged in by verifying User data exists
        const userDataFromStorage = localStorage.getItem('User');
        if (!userDataFromStorage) {
          toast.error('Please login to create a support ticket');
          return;
        }

        // 1. Get JWT from backend using axiosHelper (cookies sent automatically)
        const response = await axiosHelper.axiosPost(
          'zendesk-sso',
          {
            user_data: userData,
            return_to: returnTo,
          },
          true,
        );

        if (response?.error || !response?.data) {
          throw new Error(response?.msg || 'Failed to generate support ticket');
        }

        // 2. Submit JWT to Zendesk via form POST
        submitToZendesk(response.data.data.jwt_token, returnTo);
      } catch (error) {
        console.error('Zendesk SSO Error:', error);
        toast.error(`Failed to create support ticket: ${error.message}`);
      }
    },
    [submitToZendesk],
  );

  const handleCreateSupportTicket = useCallback(() => {
    // Get user data from application state
    const userData = {
      id: user?.info?.user?.id,
      name: user?.info?.user?.name,
      email: user?.info?.user?.email,
      // id: 'govind123' ,
      // name: 'Govind Kumar',
      // email: 'govind@seclogic.io',
      role: 'end_user',
      // organization: currentTenant || tenantList?.[0]?.name || 'seclogicinc',
      // tags: ['cspm_user', 'support_request']
    };

    // Use the ticket creation form URL as return_to
    const returnTo = 'https://seclogicinc.zendesk.com/hc/en-us/requests/new';

    authenticateWithZendesk(userData, returnTo);
    toggle(); // Close dropdown after clicking
  }, [authenticateWithZendesk, toggle, user?.info?.user?.email, user?.info?.user?.id, user?.info?.user?.name]);

  useEffect(() => {
    if (!dropdownOpen) {
      setTempTenant([]);
      setChecked(true);
      setTempList(tenantList);
    }

    const timeout = setTimeout(() => {
      setDelayed(dropdownOpen);
    }, 240);

    return () => clearTimeout(timeout);
  }, [dropdownOpen, tenantList]);

  
  return (
    <>
      <SubTenatSwitchingErrorModal
        show={errormodalShow}
        onHide={() => {
          setErrorModalShow(false);
        }}
      />
      <Dropdown nav inNavbar isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle nav>
          <div className="TopNavbar__Profile--inner" onClick={() => setValue('')}>
            <div className="Profile__Avatar">
              {/* <Avatar src={team3} imgClassname="Profile__Avatar--img" />
              <div className=''> */}
              {user.info.user.email.charAt(0).toUpperCase()}
              {/* </div> */}
            </div>
            <div>
              <>
                {/* <Tooltip title={`${currentTenant?.length > 2 ? currentTenant : tenantList[0]['tenant_name']}`}> */}
                {/* <div className="Profile__Name">Hi, {user.info.user.name}</div> */}
                {/* </Tooltip> */}
                {!isEmpty(localStorage.getItem('tenantName')) && (
                  <div className="Profile__Mail" style={{ fontSize: '12px' }} title={user.info.user.email}>
                    {localStorage.getItem('tenantName')}
                  </div>
                )}
              </>
            </div>
            <div className={`Profile__DropdownArrow`}>
              <ChevronDown
                className={`Profile__Arrow ${dropdownOpen ? 'Profile__Arrow--expanded' : ''}`}
                size={16}
                style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  transition: 'all 200ms ease',
                }}
              />
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                >
                <circle cx="9" cy="9" r="8.75" fill="#CBD5E0" stroke="#718096" stroke-width="0.5" />
                <path
                  d="M6 8L9 11L12 8"
                  stroke="#1A202C"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg> */}
            </div>
          </div>
        </DropdownToggle>

        <DropdownMenu
          bottom
          className="ProfileDropdown__Container"
          style={{
            boxShadow: delayed ? '0px 8px 18px 0px rgba(93, 106, 131, 0.10)' : 'none',
            minWidth: '223px',
            left: '-90px',
            height: '301px',
          }}>
          <div className="ProfileDropdown__Menu">
            <Box
              // onClick={() => (is_org_owner ? setModalShow(true) : setErrorModalShow(true))}
              // component={Link}

              className=" ProfileDropdown__Item_header"
              style={{ height: '49px', borderBottom: '1px solid #cbd5e0', borderLeft: '0px' }}>
              <Box>
                <Box>
                  {!isEmpty(tenantList) && (
                    <Box display="flex" alignItems="center">
                      <div className="avatar-in-dropdwon">{user.info.user.email.charAt(0).toUpperCase()}</div>
                      <Box marginLeft="10px">
                        <div className="Profile__Name" style={{ textTransform: 'capitalize' }}>
                          {' '}
                          {user.info.user.name}
                        </div>
                        <div className="Profile__Mail" style={{ fontSize: '10px' }}>
                          {user.info.user.email}
                        </div>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <Box
              // onClick={() => (is_org_owner ? setModalShow(true) : setErrorModalShow(true))}
              // component={Link}
              className="ProfileDropdown__Item ProfileDropdown__Item-1 hover:!text-[#9362d9]">
              {tenantList && tenantList?.length !== 0 && (
                <TenantSwitchingNew
                  show={modalShow}
                  onHide={() => {
                    setModalShow(false);
                    setTempTenant([]);
                    setChecked(true);
                  }}
                  templist={templist.filter(
                    tenant =>
                      tenant.tenant_name !== (currentTenant?.length > 2 ? currentTenant : tenantList[0]['tenant_name']),
                  )}
                  setTenant={setTenant}
                  onTenantSelect={onTenantSelect}
                  onSearch={onSearch}
                  tempTenant={tempTenant}
                  checked={checked}
                  value={value}
                />
              )}
              <Tooltip title={tenantList.length === 0 ? 'No other tenants exist' : ''} placement="left">
                <Box
                  onClick={() => {
                    is_org_owner ? setModalShow(true) : setErrorModalShow(true);
                  }}
                  // component={Link}
                  // className="ProfileDropdown__Item ProfileDropdown__Item-1"
                  sx={{ display: 'flex', gap: '10px', cursor: 'pointer' }}>
                  <SwitchTenanticon width="20px" />
                  <span> Switch tenants</span>
                </Box>
              </Tooltip>
            </Box>

            <Box
              component={Link}
              to="/profile/change-password"
              onClick={toggle}
              className="ProfileDropdown__Item ProfileDropdown__Item-2 hover:!text-[#9362d9]">
              <ChangePasswordIcon width="20px" />
              Change Password
            </Box>
            <Box
              component={Link}
              // to="/profile"
              onClick={handleOpenSideOverlay}
              className="ProfileDropdown__Item ProfileDropdown__Item-3 hover:!text-[#9362d9]">
              <img src={profile} style={{ color: '#1a202c !important', fill: 'rgb(72, 77, 86) !important' }} />
              Profile
            </Box>
            <Box
              onClick={handleHelpClick}
              component={Link}
              // onClick={toggle}
              //to="#"
              className="ProfileDropdown__Item ProfileDropdown__Item-4 hover:!text-[#9362d9]">
              <HelpIcon width="20px" />
              Help
            </Box>
            <Box
              onClick={handleCreateSupportTicket}
              style={{ cursor: 'pointer' }}
              className="ProfileDropdown__Item ProfileDropdown__Item-5 hover:!text-[#9362d9]">
              <SupportHandIcon />
              Support
            </Box>
            <Box
              onClick={() => {
                handleLogout();
                toggle();
              }}
              component={Link}
              to="/logout"
              className="ProfileDropdown__Item ProfileDropdown__Item-6 hover:!text-[#9362d9]">
              <LogoutIcon width="20px" />
              Logout
            </Box>
          </div>
        </DropdownMenu>
      </Dropdown>
      <SideOverlay open={openSideOverlay} onClose={() => setOpenSideOverlay(false)} width={'50%'}>
        <Profile onClose={handleCloseSideOverlay} />
      </SideOverlay>
    </>
  );
};

// export default ProfileDropdown;
export default connect(mapStateToProps)(ProfileDropdown);
